module.exports = {
      id: "vikatan-tv-usage",
      viewBox: "0 0 213 43",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#vikatan-tv",
      toString: function () {
        return this.url;
      }
    }